import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import initialState from "./initial";
import { updateObjectState, updateArrayState } from "../utils";
import log from "../../utils/log";

const useProductStore = create(
  persist(
    immer((set, get) => ({
      ...initialState, // Spread the initial state
      /**
       * Updates the cache of products in the state.
       * @param {string} action - The action to perform on the cache. Possible values: "whole" "update" "delete"
       * @param {string} query - query URL. eg: ?pagination=1
       * @param {Array} param - An array containing the product object(s) to be added, updated, or deleted.
       */
      updateProductsCache: (action, query, param) => {
        set({ productsCache: updateObjectState(get().productsCache, action, { [query]: param }) });
      },
      /**
       * Updates the cache of a single product in the state.
       * @param {string} action - The action to perform on the cache. Possible values: "whole" "update" "delete"
       * @param {Array} param - An array containing the product object(s) to be added, updated, or deleted.
       */
      updateSingleProductCache: (action, param) => {
        set({ singleProductCache: updateArrayState(get().singleProductCache, action, param) });
      },
      resetProduct: () => set(initialState), // Reset function
      //getter
      getProducts: (query) => {
        //return undefined if no cache, need axios
        //return [] if has cache but it is empty
        //return [obj] if has cache of provided query
        return get().productsCache[query];
      },
      getSingleProduct: (id) => {
        //return undefined if no cache, need axios
        //return [] if has cache but it is empty
        //return obj if has cache of provided id
        if (!id) {
          return undefined;
        }
        return get().singleProductCache.find((e) => e.id === id);
      },
    })),
    {
      name: "pearl-product", //name of store, must be unique
      storage: createJSONStorage(() => sessionStorage), // Use session storage
    }
  )
);

export default useProductStore;
